import Track from 'track/Track.js';
import BaseStepAction from './BaseStepAction.js';
import StepData from 'pattern/StepData.js';
import Pattern from 'pattern/Pattern.js';
import DeleteStepAction from './deleteStepAction.js';
import Resolution from 'engine/Resolution.js';
import {
    setAllTrackSteps} from 'actions/index.js';

class AddStepAction extends BaseStepAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({
        track,
        step,
        stepNumber,
        resolution=Track.baseResolution,
        displayResolution=Track.baseResolution,
        isRecording=true,
        isQuantized=true,
        slide
    }, updateRedux=true) {
        if (track === undefined) {
            return {};
        }
        let wholeStepNumber = Math.floor(stepNumber);
        let position = stepNumber - wholeStepNumber;

        step.slide = slide;
        let pattern = track.getEasyPattern();
        pattern
            .addStep(step, wholeStepNumber, resolution, position, undefined, undefined, isRecording);

        if (!isQuantized && displayResolution.isTriplet) {
            pattern.update();
        }

        // update redux by adding step to existing redux, instead
        // of calculating everything
        
        if (updateRedux) {
            this.updateRedux(step, wholeStepNumber, position, track, resolution, displayResolution);
        }
        return {};
    }


    get state() {
        return this.sequencerEngine.store.getState();
    }

    // This is an optimized redux update where we only update
    // for steps that we changed, instead of recalculating
    // the entire pattern
    updateRedux(step, stepNumber, position, track, resolution, displayResolution) {
        let _stepNumber = displayResolution.transformStepAtResolution2(stepNumber + position, resolution);
        stepNumber = Math.floor(_stepNumber);
        position = _stepNumber - stepNumber
        let trackNumber = track.subSequence.isTrack ? track.subSequence.id : track.id;

        let trackSteps = [... (this.state.tracks.trackSteps[trackNumber] || [])];
        let trackFills = {... (this.state.tracks.trackFills[trackNumber] || [])};
        let trackStepIds = [... (this.state.tracks.trackStepIds[trackNumber] || [])];
        let trackPianoRollSteps = this.state.tracks.trackPianoRollSteps[trackNumber] || {};
        let trackPianoRollPositions = {... this.state.tracks.trackPianoRollPositions[trackNumber]}
        let trackPianoRollDurations = this.state.tracks.trackPianoRollDurations[trackNumber] || {};
        let trackPatternSteps = this.state.tracks.trackPatternSteps[trackNumber] || {};
        trackPianoRollSteps[step.transpose] = {... trackPianoRollSteps[step.transpose]};
        trackPianoRollPositions[step.transpose] = {... trackPianoRollPositions[step.transpose]};
        trackPianoRollDurations[step.transpose] = {... trackPianoRollDurations[step.transpose]};
        trackFills = trackFills || new Array(trackSteps.length).fill(false);

        trackSteps[stepNumber] = true;
        trackStepIds[stepNumber] = step;
        trackPatternSteps[track.currentPattern] = [... trackSteps];

        trackPianoRollSteps[step.transpose][stepNumber] = true;


        trackPianoRollPositions[step.transpose][stepNumber] = position;

        let myBaseResolution = new Resolution(16, false);
        trackPianoRollDurations[step.transpose][stepNumber] = resolution.transformStepAtResolution2(
            step.duration, myBaseResolution);
        for (let i=0; i < step.duration; i++) {
            trackFills[(i + stepNumber) % trackSteps.length] = true;
        }

        this.sequencerEngine.store.dispatch(
            setAllTrackSteps(
                trackNumber,
                trackSteps,
                trackPianoRollSteps,
                trackFills,
                trackStepIds,
                trackPianoRollPositions,
                trackPianoRollDurations,
                trackPatternSteps,
            ));
    }

    undo(action, updateRedux=false) {
        // we instead delete it now!
        let deleteStepAction = new DeleteStepAction(this.sequencerEngine);
        deleteStepAction.execute(
            action.payload, updateRedux);

        if (updateRedux) {
            action.payload.track.updateSteps();
        }
    }

    getContentId(action) {
        return action.payload.step.id;
    }
}


export default AddStepAction;
